import { css } from '@emotion/core';

const styles = {
  blackColor: css`
    color: #000;
  `,
  dataSection: css`
    height: 100%;
    color: #fff;
  `,
  dataContainer: css`
  padding: 50px;
    margin: 0 auto;
    position: relative;
    color: white;
    text-align: left;
    height: 100%;
  `,
  dataContent: css`
    position: relative;
    top: 20%;
    .Typewriter {
      font-family: 'Cutive';
    font-size: 1.2rem;
    }
  `,
  subParagraph: css`
  `,
  dataTopbar: css`
    position: absolute;
    bottom: 0;
    margin: auto;
    height: 80px;
    background-color: #35495E;
    width: 100%;
    bottom: 0;
    z-index: 1;
    h5 {
      line-height: 0px;
      font-size: 0.94rem;
      font-weight: 700;
    }
  `,
};

export default styles;
